import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useSettings } from '@/hook/useSettings';
import RenderAvatarSvg from '../others/RenderAvatarSvg';

interface ServiceAvatar {
  shape: string;
  color1: string;
  color2: string;
}

interface ServiceAvatarDropdownProps {
  value: ServiceAvatar;
  onChange: (value: ServiceAvatar) => void;
  rowNumber?: number;
}

export function ServiceAvatarDropdown({ value, onChange, rowNumber }: ServiceAvatarDropdownProps) {
  const { settingsData } = useSettings();

  if (!settingsData?.serviceAvatar) return null;

  return (
    <Select
      value={`${value.shape}-${value.color1}-${value.color2}`}
      onValueChange={(val: string) => {
        const [shape, color1, color2] = val.split('-');
        onChange({ shape, color1, color2 });
      }}
    >
      <SelectTrigger className="w-full">
        <SelectValue>
          <div className="flex items-center gap-2">
            <RenderAvatarSvg {...value} size={24} />
            <span>Avatar {rowNumber ?? ''}</span>
          </div>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {settingsData.serviceAvatar.map((avatar: ServiceAvatar, index) => (
          <SelectItem
            key={`${avatar.shape}-${avatar.color1}-${avatar.color2}`}
            value={`${avatar.shape}-${avatar.color1}-${avatar.color2}`}
          >
            <div className="flex items-center gap-2">
              <RenderAvatarSvg {...avatar} size={24} />
              <span>Avatar {index + 1}</span>
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
